import { storageHelper } from '../utils/functions/storageHelper';
import { sendNotification } from '../utils/functions';

export const generateToken = async () => {
  const hasAccessToken = storageHelper.getItem('token');
  return isTokenValid() ? hasAccessToken : null;
};

export const removeToken = (message: string) => {
  const REDIRECT_TIME = 6000;

  const toastConfig = {
    autoClose: REDIRECT_TIME,
    hideProgressBar: false,
    type: 'error',
  };

  sendNotification(message, toastConfig);

  storageHelper.removeItem('token');
  storageHelper.setItem('callback_url', window.location.href);

  setTimeout(() => {
    window.location.replace('/');
  }, REDIRECT_TIME);
};

const isTokenValid = () => {
  storageHelper.removeItem('callback_url');
  const token = storageHelper.getItem('token');

  if (token) {
    const payload = token.split('.')[1];
    const decodedPayload = JSON.parse(atob(payload));
    const expirationDate = decodedPayload.exp * 1000;
    return Date.now() < expirationDate;
  }

  return null;
};
